import React, { useContext } from "react";
import Button from "./tabButton/TabButton";
// import personal from "../../../assets/icons/tabNav/personal.svg";
// import buddies from "../../../assets/icons/tabNav/tribe.svg";
// import network from "../../../assets/icons/tabNav/network.svg";

import ColourContext from "../../../contexts/ColourContext";
import { colourThemes } from "../../../styles/colourPalettes";

import style from "./TabNav.module.css";
import UserContext from "../../../contexts/UserContext";

const TabNav = () => {
  const { key: colourKey } = useContext(ColourContext);
  const colour = colourThemes[colourKey];

  const { state: userState } = useContext(UserContext);
  // Disable navigation until the Pesonal Intro has been seen
  const disableButtons = !userState.seenPersonalIntro;

  const personalIcon = (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="50"
        cy="50"
        r="48.5"
        fill={colour}
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
  const buddiesIcon = (
    <svg
      width="116"
      height="104"
      viewBox="0 0 116 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="37.9999"
        cy="18.6667"
        r="16.6667"
        fill="#6FCF97"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="77.9999"
        cy="18.6667"
        r="16.6667"
        fill="#56CCF2"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="19.111"
        cy="52"
        r="16.6667"
        fill="#BB6BD9"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="57.9999"
        cy="52"
        r="16.6667"
        fill={colour}
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="96.8888"
        cy="52"
        r="16.6667"
        fill="#EB5757"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="37.9999"
        cy="85.3334"
        r="16.6667"
        fill="#2F80ED"
        stroke="white"
        strokeWidth="3"
      />
      <circle
        cx="77.9999"
        cy="85.3334"
        r="16.6667"
        fill="#F2C94C"
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  );
  const networkIcon = (
    <svg
      width="116"
      height="102"
      viewBox="0 0 116 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="34.2611" cy="10.9698" r="9.96981" fill="white" />
      <circle cx="58.1886" cy="10.9698" r="9.96981" fill="white" />
      <circle
        cx="82.1163"
        cy="10.9698"
        r="9.96981"
        fill="#F2C94C"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="22.2974"
        cy="30.9094"
        r="9.96981"
        fill="#2D9CDB"
        stroke="white"
        strokeWidth="2"
      />
      <circle cx="46.2249" cy="30.9094" r="9.96981" fill="white" />
      <circle cx="70.1524" cy="30.9094" r="9.96981" fill="white" />
      <circle cx="94.0799" cy="30.9094" r="9.96981" fill="white" />
      <circle cx="34.2611" cy="50.8491" r="9.96981" fill="white" />
      <circle cx="9.96981" cy="50.9698" r="9.96981" fill="white" />
      <circle
        cx="58.1886"
        cy="50.8491"
        r="9.96981"
        fill={colour}
        stroke="white"
        strokeWidth="2"
      />
      <circle cx="82.1163" cy="50.8491" r="9.96981" fill="white" />
      <circle cx="105.97" cy="50.9698" r="9.96981" fill="white" />
      <circle cx="22.2974" cy="70.7887" r="9.96981" fill="white" />
      <circle cx="46.2249" cy="70.7887" r="9.96981" fill="white" />
      <circle cx="70.1524" cy="70.7887" r="9.96981" fill="white" />
      <circle
        cx="94.0799"
        cy="70.7887"
        r="9.96981"
        fill="#6FCF97"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="34.2611"
        cy="90.7283"
        r="9.96981"
        fill="#EB5757"
        stroke="white"
        strokeWidth="2"
      />
      <circle cx="58.1886" cy="90.7283" r="9.96981" fill="white" />
      <circle cx="82.1163" cy="90.7283" r="9.96981" fill="white" />
    </svg>
  );

  return (
    <nav className={style.container} style={{ borderColor: colour }}>
      <Button
        title="Personal"
        to="/personal/"
        icon={personalIcon}
        disabled={false}
      />
      <Button
        title="Buddies"
        to="/buddies/"
        icon={buddiesIcon}
        disabled={disableButtons}
      />
      <Button
        title="Meet"
        to="/meet/"
        icon={networkIcon}
        disabled={disableButtons}
      />
    </nav>
  );
};

TabNav.propTypes = {};
TabNav.defaultProps = {};

export default TabNav;
